import lookup from 'country-code-lookup';
import { useTranslations } from 'next-intl';
import React from 'react';

type OrderAddressProps = {
  company?: string | null;
  taxNumber?: string | null;
  street?: string | null;
  street2?: string | null;
  streetNumber?: string | null;
  postalCode?: string | null;
  city?: string | null;
  country?: string | null;
  firstName?: string | null;
  lastName?: string | null;
};

export default function OrderAddress({
  firstName,
  lastName,
  company,
  taxNumber,
  street,
  street2,
  streetNumber,
  postalCode,
  city,
  country,
}: Readonly<OrderAddressProps>) {
  const t = useTranslations('OrderAddress');

  return (
    <address className="mt-4 not-italic text-neutral-50">
      <span className="text-md font-bold text-neutral-100">
        {firstName} {lastName}
      </span>
      <br />
      {company && (
        <>
          {company}
          <br />
        </>
      )}
      {taxNumber && (
        <>
          {t('VAT ID')} {taxNumber}
          <br />
        </>
      )}
      {street} {streetNumber}
      {street2 && (
        <>
          <br />
          {street2}
        </>
      )}
      <br />
      {postalCode} {city}
      {country && (
        <>
          <br />
          {lookup.byIso(country)?.country}
        </>
      )}
    </address>
  );
}
